(function(){

	function setProvinceList(item) {
		var itemProvince;
		var itemProvinceArray;
		$(".js-select.province").find("select").empty();
		if($(item).attr("data-provinces").length > 0) {
			itemProvince = $(item).attr("data-provinces");
			if(itemProvince !== "[[") {
				itemProvinceArray = JSON.parse(itemProvince);
				
				$(itemProvinceArray).each(function() {
					$(".js-select.province").find("select").append(
						'<option value="'+ $(this)[0] +'">'+ $(this)[0] +'</option>'
					)
				});
			}
			
		}

	}

    $(document).ready(function(){
      $("#addressProvince").on("change", function(){
        
          if($("#addressProvince").val() === null) {
            $("#submitBtn").attr("disabled", true);
          } else {
            if($("#submitBtn").attr("data-password") === "true" ) {
              $("#submitBtn").removeAttr("disabled");
            }
          }
        })
    })
  
	$(window).on("load", function () {
		let countrySelects = $(".js-select.country");
		let provinceSelects = $(".js-select.province");

		if(countrySelects) {
			countrySelects.each(function () {
				const that = $(this);
				let defOption = $(
					'<option value="Country" data-provinces="[]" selected disabled></option>'
				);

				$(this).find("option").each(function() {
					if($(this).val() == "Italy" || $(this).val() == "Italia") {
						defOption = $(
							'<option value="'+ $(this).val() +'" data-provinces="'+ $(this).attr("data-provinces") +'" selected>'+ $(this).text() +'</option>'
						);
						setProvinceList($(this))
					}
				});
	
				$(this).find("option:first-child").remove();
				$(this).find("select").prepend(defOption);
	
				$(this)
					.find("select")
					.change(function (e) {
						$(this).css("color", "rgb(var(--color-foreground), 1)");
						that.find(".placeholder-select").remove();
						
						var selectedValue = $(this).val();

						$(this).find("option").each(function() {
							if(selectedValue == $(this).val()) {
								setProvinceList($(this))
							}
						});

					});
			});
		}

		if(provinceSelects) {
			provinceSelects.each(function () {
				const that = $(this);
				const defOption = $(
					'<option value="Province" selected disabled></option>'
				);

				const ph = $(
					'<div class="placeholder-select">Province <span>*</span></div>'
				);

				$(this).find("option:first-child").remove();
				$(this).prepend(ph);
				$(this).find("select").prepend(defOption);

				$(this)
					.find("select")
					.change(function (e) {
						$(this).css("color", "rgb(var(--color-foreground), 1)");
						$(this).parent().find(".placeholder-select").remove();

					});
			});
		}

        if($("#addressProvince").val() === null) {
          $("#submitBtn").attr("disabled", true);
        } else {
          if($("#submitBtn").attr("data-password" === true )) {
              $("#submitBtn").removeAttr("disabled");
            }
        }

        
	});
	
	$(document).on("click", ".login__toggle", function () {
		$(".login__reset").toggle();
		$(".login__form").toggle();
	});

})();



